module.exports = __webpack_public_path__ + "static/media/pcam.a3dd03cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/pcam.png
// module id = 460
// module chunks = 0